// eslint-ignore
export default 
`<p>Individual Checkboxes Stacked (Default)</p>
<Checkbox v-model="checkboxGroup" text="Orange" value="Orange"></Checkbox>
<Checkbox v-model="checkboxGroup" text="Apple" value="Apple"></Checkbox>
<Checkbox v-model="checkboxGroup" text="Pineapple" value="Pineapple"></Checkbox>
<Checkbox v-model="checkboxGroup" text="Banana" value="Banana" disabled></Checkbox>


<p>Individual Checkboxes Inline</p>
<Checkbox v-model="checkboxGroup" text="Orange" value="Orange" inline></Checkbox>
<Checkbox v-model="checkboxGroup" text="Apple" value="Apple" inline></Checkbox>
<Checkbox v-model="checkboxGroup" text="Pineapple" value="Pineapple" inline></Checkbox>
<Checkbox v-model="checkboxGroup" text="Banana" value="Banana" disabled inline></Checkbox>


<p>Array of Checkboxes Stacked (Default)</p>
<Checkbox 
  v-model="checkboxGroup"
  v-for="option in options" 
  :option="option" 
  :key="option.value" 
  :text="option.text"
  :value="option.value"
  :disabled="option.disabled"
>
</Checkbox>


<p>Array of Checkboxes Inline</p>
<Checkbox 
  v-model="checkboxGroup"
  v-for="option in options" 
  :option="option" 
  :key="option.value" 
  :text="option.text"
  :value="option.value"
  :disabled="option.disabled"
  inline
>
</Checkbox>

<p>Values:{{ checkboxGroup }}</p>



export default {
  components: {
    Checkbox
  },

  data () {
    return {
      checkboxGroup: [],
      options: [
        { text: 'Orange', value: 'Orange', disabled: false },
        { text: 'Apple', value: 'Apple', disabled: false },
        { text: 'Pineapple', value: 'Pineapple', disabled: false },
        { text: 'Banana', value: 'Banana', disabled: true}
      ],
    }
  }
}`;